var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"CSChatThai",staticStyle:{"overflow-y":"hidden","background":"white"},attrs:{"id":"inspire"}},[(_vm.progress)?_c('v-progress-circular',{staticStyle:{"margin":"auto"},attrs:{"size":250,"width":10,"indeterminate":"","color":"blue"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-260665ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/authenCallbackOneid.vue
// module id = 432
// module chunks = 0